<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <h4 class="f-bold pt-2 pl-3 cl-primary text-left" v-if="!id">
          Add Promotion
        </h4>
        <h4 class="f-bold pt-2 pl-3 cl-primary text-left" v-if="id">
          Edit Promotion
        </h4>
      </div>
      <div class="col-12 col-md-6">
        <nav aria-label="breadcrumb">
          <ol
            class="breadcrumb float-right"
            style="background-color: transparent"
          >
            <li class="breadcrumb-item">
              <router-link to="/admin/dashboard">Dashboard</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/admin/promotions">Data Promotion</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Form Promotion
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="d-flex justify-content-around" v-if="loading">
      <loader-component></loader-component>
    </div>
    <form @submit.prevent="submit" v-if="!loading" class="text-left">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for=""> Title Promotion</label>
            <input
              type="text"
              class="form-control"
              id="title"
              aria-describedby="title"
              placeholder="Title Promotion"
              v-model="form.title"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for=""> Promotion Code</label>
            <input
              type="text"
              class="form-control"
              id="code"
              aria-describedby="code"
              placeholder="Promotion Code"
              v-model="form.code"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="">Discount</label>
            <input
              type="number"
              class="form-control"
              id="discount"
              aria-describedby="discount"
              placeholder="Discount"
              v-model="form.discount"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="">status</label>
            <select class="form-control" v-model="form.status">
              <option value="1">Active</option>
              <option value="2">In Active</option>
            </select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="">Expired At</label>
            <input
              type="date"
              class="form-control"
              id="expired_at"
              aria-describedby="expired_at"
              placeholder="Expired At"
              v-model="form.expired_at"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group text-left">
            <label for="Image" class="text-secondary text-left">Image</label>
            <input
              type="file"
              @change="handleUploadImage()"
              class="form-control-file"
              ref="images"
              id="images"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="description" class="text-secondary text-left"
              >Description</label
            >
            <textarea
              name="description"
              id="description"
              placeholder="Description"
              cols="30"
              rows="7"
              v-model="form.description"
              class="form-control"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="d-flex justify-content-end">
            <button class="btn btn-primary px-5" type="submit" v-if="!id">
              Save
            </button>
            <button class="btn btn-primary px-5" type="submit" v-if="id">
              Update
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import Vue from "vue";
import LoaderComponent from "../../components/Loader.vue";
export default {
  props: ["id"],
  components: { LoaderComponent },
  computed: {
    userLogin: function () {
      return this.$store.getters.getProfileCustomers;
    },
  },
  data() {
    return {
      loading: false,
      form: {
        code: "",
        discount: "",
        status: "",
        expired_at: "",
        create_by: "",
        id: "",
        max_amount: 0,
        image: "",
        title: "",
        description: "",
      },
    };
  },

  mounted() {
    this.form.create_by = this.userLogin.id;
    this.getProfileLogin();
    console.log(this.userLogin);
    if (this.id) {
      this.getDetailPromotion();
    }
  },
  methods: {
    getProfileLogin() {
      this.$store.dispatch("getProfileCustomers");
    },

    handleUploadImage() {
      this.form.image = this.$refs.images.files[0];
      console.log(this.form.image);
    },

    submitPromotion() {
      Vue.swal({
        title: "Are you sure?",
        text: "Your data will be entered",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Submit Promotion!",
      }).then((result) => {
        if (result.isConfirmed) {
          let formData = new FormData();
          this.loading = true;

          formData.append("title", this.form.title);
          formData.append("description", this.form.description);
          formData.append("image", this.form.image);
          formData.append("max_amount", 0);
          formData.append("code", this.form.code);
          formData.append("discount", this.form.discount);
          formData.append("status", this.form.status);
          formData.append("expired_at", this.form.expired_at);
          this.$store
            .dispatch("postPromotion", formData)
            .then((res) => {
              this.loading = false;
              console.log(res);
              this.resetForm();
              Vue.swal(
                res.data.status,
                "Your data is already added",
                "success"
              ).then(() => {
                this.toList();
              });
            })
            .catch((err) => {
              let errorMsg = "";
              this.loading = false;
              Object.keys(err.response.data).forEach(function (key) {
                let errorItem = key.charAt(0).toUpperCase() + key.slice(1);
                let errorCause = "";
                let errorLists = err.response.data[key];
                for (var prop in errorLists) {
                  errorCause += "<li>" + errorLists[prop] + "</li>";
                }
                errorMsg +=
                  "<ul style='list-style: none; text-align: left;' class='text-left'><b>" +
                  errorItem +
                  "</b>" +
                  errorCause +
                  "</ul><br>";
              });

              Vue.swal({
                icon: "error",
                title: "Error!",
                html: errorMsg,
              });
              console.log(err.response.data);
            });
        }
      });
    },

    submit() {
      if (this.id) {
        this.updatePromotion();
      } else {
        this.submitPromotion();
      }
    },

    resetForm() {
      (this.form.title = ""),
        (this.form.subtitle = ""),
        (this.form.image = null);
    },

    toList() {
      this.$router.push("/admin/promotions");
    },

    getDetailPromotion() {
      this.loading = true;
      const endpoint = "promotion/" + this.id;
      this.$api.get(endpoint, (status, data, message) => {
        console.log(status);
        if (status == 200) {
          this.loading = false;
          this.form = data.promotion;
          console.log(data);
        } else {
          this.loading = false;
          console.log(message);
        }
      });
    },

    updatePromotion() {
      console.log(this.id);
      Vue.swal({
        title: "Are you sure?",
        text: "Your data will be updated",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Update Promotion!",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("ini id: " + this.id);
          let formData = new FormData();
          this.loading = true;
          formData.append("id", this.id);
          formData.append("description", this.form.description);
          formData.append("image", this.form.image);
          formData.append("max_amount", 0);
          formData.append("code", this.form.code);
          formData.append("discount", this.form.discount);
          formData.append("status", this.form.status);
          formData.append("expired_at", this.form.expired_at);
          this.$store
            .dispatch("updatePromotion", formData)
            .then((res) => {
              this.loading = false;
              console.log(res);
              this.resetForm();
              Vue.swal(
                res.data.status,
                "Your data is already added",
                "success"
              ).then(() => {
                this.toList();
              });
            })
            .catch((err) => {
              let errorMsg = "";
              this.loading = false;
              Object.keys(err.response.data).forEach(function (key) {
                let errorItem = key.charAt(0).toUpperCase() + key.slice(1);
                let errorCause = "";
                let errorLists = err.response.data[key];
                for (var prop in errorLists) {
                  errorCause += "<li>" + errorLists[prop] + "</li>";
                }
                errorMsg +=
                  "<ul style='list-style: none; text-align: left;' class='text-left'><b>" +
                  errorItem +
                  "</b>" +
                  errorCause +
                  "</ul><br>";
              });

              Vue.swal({
                icon: "error",
                title: "Error!",
                html: errorMsg,
              });
              console.log(err.response.data);
            });
        }
      });
    },
  },
};
</script>
